module.exports = "<div class=\"item-react\" *ngIf=\"enableSetting\">\r\n    <app-base-reaction\r\n        [reactIndex]=\"reactIndex\"\r\n        [disabled]=\"disabled\"\r\n        (_onReact)=\"changeReact($event)\"\r\n    ></app-base-reaction>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/commons/chat/communication-reaction/communication-reaction.component.html
// module id = ./src/app/commons/chat/communication-reaction/communication-reaction.component.html
// module chunks = main